import { Container } from '@/components/ui/template/Container'
import { ButtonLink } from '@/components/ui/Button'
import { SlideIn } from '@/components/ui/transitions/SlideIn'
import { useWindowSize } from '@/hooks/helpers/useWindowSize'
import External from '@/assets/icons/External.svg?react'
import { DAO_URL, DAO_URLS } from '@/config/constants.ts'
import { testIdFactory } from '@/utils/test-id-factory.ts'

const SUB_DAOS = [
	{ name: 'minister', label: 'Minister SubDAO', href: DAO_URLS.minister },
	{ name: 'buyback', label: 'Buyback SubDAO', href: DAO_URLS.buyback }
] as const

export function DaoAnnouncementSection() {
	const { isMobile } = useWindowSize()

	return (
		<Container className="bg-green-10">
			<Container.Content className="flex flex-col md:flex-row justify-between items-center gap-10 overflow-hidden">
				<SlideIn from={isMobile ? 'top' : 'right'} className="md:order-2">
					<img
						src="/images/pepper-inc-tower.png"
						alt="PEPPER DAO"
						className="aspect-square object-contain max-w-[180px] md:max-w-[240px]"
						loading="lazy"
					/>
				</SlideIn>
				<SlideIn from={isMobile ? 'bottom' : 'left'} className="flex flex-col gap-6 md:order-1">
					<h2 className="uppercase text-[3rem] md:text-[3.75rem] text-neutral-100 font-bold text-center md:text-left leading-none">
						PEPPER treasury &amp; voting have moved to Aragon
					</h2>
					<p className="text-neutral-40 text-[1.5rem] leading-[26px]">
						Both the community treasury and governance voting have moved to the new{' '}
						<span className="font-bold text-neutral-100">PEPPER DAO on Aragon</span>, supervised by the
						newly elected <span className="font-bold text-neutral-100">PEPPER Ministers</span>. Proposals
						and treasury decisions are now managed end-to-end on Aragon.
					</p>
					<ButtonLink
						to={DAO_URL}
						target="_blank"
						variant="danger"
						className="md:self-start py-5 px-10 leading-none"
						data-testid={testIdFactory.daoAnnouncementLink()}
					>
						Explore the PEPPER DAO
					</ButtonLink>
					<div className="flex flex-col sm:flex-row gap-3 sm:gap-8 justify-center md:justify-start items-center">
						{SUB_DAOS.map(subDao => (
							<a
								key={subDao.name}
								href={subDao.href}
								target="_blank"
								rel="noopener noreferrer"
								className="flex items-center gap-2 text-[1.5rem] text-green-60 font-bold underline underline-offset-4"
								data-testid={testIdFactory.daoAnnouncementSubLink(subDao.name)}
							>
								{subDao.label}
								<External className="w-[1rem]" />
							</a>
						))}
					</div>
				</SlideIn>
			</Container.Content>
		</Container>
	)
}
